export const updatedResourceAllocationGrid = (formData) => {
    if (!formData.sprintsMilestones || !formData.resourceTable) return [];

    return formData.sprintsMilestones.map((sprint, sprintIndex) => ({
        sprint,  // ✅ Store full sprint object reference
        allocations: formData.resourceTable.reduce((acc, resource) => {
            const allocationPercentage = formData.allocationMatrix?.[sprintIndex]?.allocations?.[resource.id] || 50;
            const allocatedHours = (allocationPercentage / 100) * sprint.workingDays * formData.businessHoursPerDay;

            acc[resource.id] = {
                resource,  // ✅ Store full resource object reference
                allocationPercentage,
                allocatedHours
            };
            return acc;
        }, {})
    }));
};
